export default __webpack_public_path__ + "media/images/supplied/img-welder-fade-02f0a170bcc2e41ad2fcb1be4a33fac2.jpg";